module.exports = __webpack_public_path__ + "h5/img/live-logo.d5d1aef7.gif";